import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import 'linaria';
import { PlainExtension, isDocNodeEmpty, ManagerPhase, getPluginState, extensionDecorator } from '@remirror/core';
import { Decoration, DecorationSet } from '@remirror/pm/view';

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var isEmptyStyles = "remirror-is-empty";
/**
 * Used to denote a node is empty.
 *
 * Currently used by the placeholder extension.
 */

var EMPTY_NODE_CLASS_NAME = isEmptyStyles;
var EMPTY_NODE_CLASS_SELECTOR = /*#__PURE__*/".".concat(EMPTY_NODE_CLASS_NAME);
var PlaceholderExtension = (_dec = /*#__PURE__*/extensionDecorator({
  defaultOptions: {
    emptyNodeClass: EMPTY_NODE_CLASS_NAME,
    placeholder: ''
  }
}), /*#__PURE__*/_dec(_class = class PlaceholderExtension extends PlainExtension {
  get name() {
    return 'placeholder';
  }

  createAttributes() {
    return {
      'aria-placeholder': this.options.placeholder
    };
  }

  createPlugin() {
    return {
      state: {
        init: (_, state) => _objectSpread(_objectSpread({}, this.options), {}, {
          empty: isDocNodeEmpty(state.doc)
        }),
        apply: (tr, pluginState, _, state) => {
          return applyState({
            pluginState,
            tr,
            extension: this,
            state
          });
        }
      },
      props: {
        decorations: state => {
          return createDecorationSet({
            state,
            extension: this
          });
        }
      }
    };
  }

  onSetOptions(parameter) {
    var changes = parameter.changes;

    if (changes.placeholder.changed && this.store.phase >= ManagerPhase.EditorView) {
      // update the attributes object
      this.store.updateAttributes();
    }
  }

}) || _class);

/**
 * Apply state for managing the created placeholder plugin.
 *
 * @param params
 */
function applyState(_ref) {
  var pluginState = _ref.pluginState,
      extension = _ref.extension,
      tr = _ref.tr,
      state = _ref.state;

  if (!tr.docChanged) {
    return pluginState;
  }

  return _objectSpread(_objectSpread({}, extension.options), {}, {
    empty: isDocNodeEmpty(state.doc)
  });
}
/**
 * Creates a decoration set from the passed through state
 *
 * @param params.extension
 * @param params.state
 */


function createDecorationSet(_ref2) {
  var extension = _ref2.extension,
      state = _ref2.state;

  var _getPluginState = getPluginState(extension.pluginKey, state),
      empty = _getPluginState.empty;

  var _extension$options = extension.options,
      emptyNodeClass = _extension$options.emptyNodeClass,
      placeholder = _extension$options.placeholder;

  if (!empty) {
    return;
  }

  var decorations = [];
  state.doc.descendants((node, pos) => {
    var decoration = Decoration.node(pos, pos + node.nodeSize, {
      class: emptyNodeClass,
      'data-placeholder': placeholder
    });
    decorations.push(decoration);
  });
  return DecorationSet.create(state.doc, decorations);
}

export { EMPTY_NODE_CLASS_NAME, EMPTY_NODE_CLASS_SELECTOR, PlaceholderExtension };
